import Component, { mixins } from 'vue-class-component'
import MixinStock from '@/mixins/stock'
import { StockEnzyme } from '@/interfaces/stock'
import { capitalizeFirstLetter } from '@/shared/utils'

@Component
export default class Chat extends mixins(MixinStock) {
  public messages: object[] = []
  public message: string = ''

  get hasMessages() {
    return this.messages.length > 0
  }

  get isMessageEmpty() {
    return this.message.length === 0
  }

  public sendMessage() {
    if (this.isMessageEmpty) {
      return
    }

    this.checkCheatCode()

    this.$feathers.service('api/chat')
      .create({
        message: this.message,
      })
      .then(() => {
        this.message = ''
        setTimeout(this.scrollToBottom, 100)
      })
      .catch((err) => {
        // TODO: display err.message
      })
  }

  public mounted() {
    this.addMessageListener()
    this.scrollToBottom()
  }

  private addMessageListener() {
    this.$feathers.service('api/chat')
      .on('created', (message) => {
        this.messages.push(message)
      })
  }

  private scrollToBottom() {
    this.$nextTick(() => {
      const messages = this.$refs.messages as HTMLScriptElement
      messages.scrollTop = messages.scrollHeight
    })
  }

  private checkCheatCode() {
    if (this.message === 'ilm') {
      this.stockEnzymes.each((enzyme: StockEnzyme) => {
        this.storeUpdateTeamEnzyme({
          team: this.activeTeam,
          enzyme: this.$enzymes.find(enzyme.id),
          quantity: 100,
        })
      })

      this.$flits.success(`${capitalizeFirstLetter(this.activePlayer.name)} is vals aan het spelen.`)
    }

    if (this.message === 'ilm undo') {
      this.stockEnzymes.each((enzyme: StockEnzyme) => {
        this.storeUpdateTeamEnzyme({
          team: this.activeTeam,
          enzyme: this.$enzymes.find(enzyme.id),
          quantity: -200,
        })
      })
      this.$flits.success(`${capitalizeFirstLetter(this.activePlayer.name)} is niet vals aan het spelen.`)
    }

    if (this.message.startsWith('give me')) {
      const [, , title, qty] = this.message.split(' ')

      this.storeUpdateTeamEnzyme({
        team: this.activeTeam,
        enzyme: this.$enzymes.findByName(title),
        quantity: Number.parseInt(qty, 10),
      })
    }
  }
}
